import { Icon } from "@/components/icons";
import { Tooltip } from "@/components/tooltip";

/**
 * Circled "i" next to a label; hovering it shows `text` in the brand tooltip.
 * Inherits the text color of its parent so it matches the adjacent label.
 */
export function InfoHint({ text }: { text: string }) {
  return (
    <Tooltip description={text}>
      <span className="flex size-4 items-center justify-center">
        <Icon name="info" size={20} style={{ fontSize: "16px" }} label="More info" />
      </span>
    </Tooltip>
  );
}
